var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import CookieConsentComponent from "../components/cookie-consent.component";
import { isMandatory } from "../enums/category.enum";
import { Status } from "../enums/status.enum";
import { cookiesMadeSimpleProperties } from "../properties/cookies-made-simple.property";
var CookieService = function () {
    var COOKIE_NAME = cookiesMadeSimpleProperties.getCookieName;
    var COOKIE_DAYS = cookiesMadeSimpleProperties.getCookieValidityInDays;
    var cookieConsentComponent;
    var cookieIsMissing = function () {
        var cookies = "; ".concat(document.cookie);
        var cookiePattern = new RegExp("(?:^|; )".concat(encodeURIComponent(COOKIE_NAME), "="));
        return !cookiePattern.test(cookies);
    };
    /**
     * NOT WORKING AS EXPECTED
     *
     * The goal is to ensure users have cookies that are either accepted or refused.
     * If some plugin deletes cookies automatically, cookie consent component will show up
     * infinitely in such way that user hasn't access to website.
     *
     * A better solution would be to identify a cookie deletion and popup another modal saying that
     * a cookie deletion was detected and informing that website cannot work without mandatory cookies.
     */
    var verifyCookieConsentAtInterval = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    }); };
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            cookieConsentComponent = new CookieConsentComponent();
            return [2 /*return*/];
        });
    }); };
    var getCookiesPreferences = function () {
        var _a;
        var value = "; ".concat(document.cookie);
        var parts = value.split("; ".concat(COOKIE_NAME, "="));
        if (parts && parts.length === 2) {
            var cookieValue = (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(';').shift();
            if (cookieValue) {
                return JSON.parse(cookieValue);
            }
        }
        return {};
    };
    var getOptionalCookies = function () {
        var cookies = [];
        for (var _i = 0, _a = Object.entries(cookiesMadeSimpleProperties.getCookies); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], props = _b[1];
            var cookie = window["".concat(cookiesMadeSimpleProperties.getGlobalPrefix).concat(key)];
            if (cookie) {
                if (isMandatory(cookie.category)) {
                    continue;
                }
                cookie.props = props;
                cookies.push(cookie);
            }
            else {
                console.error("CMS: undefined cookie [".concat(key, "] !"));
            }
        }
        var preferences = getCookiesPreferences();
        cookies.forEach(function (cookieData) {
            var status = preferences[cookieData.key];
            if (status) {
                cookieData.initialStatus = status;
                cookieData.status = status;
            }
            else {
                cookieData.initialStatus = Status.PENDING;
                cookieData.status = Status.PENDING;
            }
        });
        return cookies;
    };
    var activate = function (cookie) {
        console.debug("CMS: Activating ".concat(cookie.key));
        if (!cookie.isInitialized) {
            cookie.activateCallback(cookie.props);
            cookie.isInitialized = true;
        }
        else {
            console.debug("CMS: Cookie already activated");
        }
        return;
    };
    var deactivate = function (cookie) {
        cookie.deactivateCallback(cookie.props);
    };
    var applyAndSave = function (cookies) {
        apply(cookies);
        save(cookies);
    };
    var apply = function (cookies) {
        var deactivatedCookie = false;
        for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
            var cookie = cookies_1[_i];
            if (cookie.status === Status.ACCEPTED) {
                activate(cookie);
            }
            else if (cookie.status === Status.REFUSED) {
                deactivate(cookie);
                deactivatedCookie = cookie.initialStatus !== cookie.status;
            }
            else {
                console.debug("CMS: Cookie [" + cookie.key + "] waiting for approval");
            }
        }
        return deactivatedCookie;
    };
    var save = function (cookies) {
        var preferences = JSON.stringify(cookies.reduce(function (acc, item) {
            acc[item.key] = item.status ? item.status : Status.PENDING;
            return acc;
        }, {}));
        var expires = '';
        if (COOKIE_DAYS) {
            var date = new Date();
            date.setTime(date.getTime() + (COOKIE_DAYS * 24 * 60 * 60 * 1000));
            expires = "; expires=".concat(date.toUTCString());
        }
        var cookie = "".concat(COOKIE_NAME, "=").concat(preferences).concat(expires, "; SameSite=Strict; path=/");
        document.cookie = cookie;
    };
    return {
        getOptionalCookies: getOptionalCookies,
        applyAndSaveCookiePreferences: applyAndSave,
        applyCookiePreferences: apply,
        saveCookiePreferences: save,
        initialize: init,
    };
};
export default CookieService();
